import script from "./NewsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=ts"

import "./NewsList.vue?vue&type=style&index=0&id=5465556a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5465556a"]])

export default __exports__